export const CUSTODIAN_SYNC_API_KEYS = [
  "id",
  "name",
  "srcName",
  "lastLink",
  "cost",
  "value",
  "sourceValue",
  "sourceValueTickerId",
  "accountNumber",
  "costTickerId",
  "valueTickerId",
  "costExchangeRate",
  "valueExchangeRate",
  "sortKey",
  "note",
  "description",
  "star",
  "past",
  "isCompleted",
  "linkType",
  "linkProviderAccountId",
  "linkAccountId",
  "linkAccountContainer",
  "linkProviderId",
  "linkProviderName",
  "linkAccountMask",
  "linkAccountName",
  "relatedId",
  "type",
  "aum",
  "ownership",
  "costType",
  "cmtdCap",
  "cmtdCapTickerId",
  "subType",
  "taxDetails",
  "rate",
  "assetClassId",
  "worldRegionId",
  "sector",
  "marketCapType",
  "autopilotRules",
  "extra",
  "parentId",
  "hidden",
  "irrType",
  "symbol",
  "origin"
];

export const CUSTODIAN_CASHFLOW_API_KEYS = [
  "id",
  "date",
  "note",
  "cashIn",
  "cashInTickerId",
  "cashInExchangeRate",
  "cashOut",
  "cashOutTickerId",
  "cashOutExchangeRate"
];

export const FUND_SCHEDULE_API_KEYS = ["id", "date", "type", "value", "valueTickerId", "note"];
